<app-template-date [disabled]="disabled" [value]="value" [control]="control" [required]="required" [label]="label" />
